import { render, staticRenderFns } from "./LegalContractView.vue?vue&type=template&id=1f39f37a&scoped=true"
import script from "./LegalContractView.vue?vue&type=script&lang=js"
export * from "./LegalContractView.vue?vue&type=script&lang=js"
import style0 from "./LegalContractView.vue?vue&type=style&index=0&id=1f39f37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f39f37a",
  null
  
)

export default component.exports